var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "object-block-document", class: _vm.objectBlockClasses },
    [
      _c(
        "div",
        { staticClass: "object-block__header" },
        [
          _c(
            "div",
            { staticClass: "object-block__header-title-container" },
            [
              _c("CompassObject", {
                attrs: { object: "document", size: "small" }
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "object-block__header-name-container" },
                  [
                    _c("BlockName", {
                      attrs: {
                        name: _vm.data.number || _vm.data.name,
                        link: !_vm.displayLink ? _vm.linkCard : null
                      }
                    }),
                    _vm._v(" "),
                    _vm.status
                      ? _c(
                          "CompassTag",
                          {
                            attrs: {
                              type: "dot",
                              color: "custom",
                              customColor: _vm.status.color
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.status.label) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                !!_vm.data.amount
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "typographies-paragraph-small-regular object-block__header-caption"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$filters.numberFormatWithOptions(
                                _vm.data.amount,
                                { precision: _vm.numformat.precision },
                                true
                              )
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.displayLink
            ? _c("CompassLink", {
                attrs: {
                  label: _vm.linkLabel,
                  link: _vm.linkCard,
                  target: "_blank"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.variant === _vm.OBJECT_BLOCK_VARIANT.LINKED
            ? _c("CompassIconButton", {
                attrs: { icon: "close" },
                on: {
                  click: function($event) {
                    return _vm.$emit("unlink")
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.displayDescriptionList && _vm.hasDescriptionListItem
        ? _c(
            "BlockDescriptionListPart",
            _vm._b(
              {
                attrs: {
                  showCompany: _vm.displayCompanyDescriptionItem,
                  showContact: _vm.displayContactDescriptionItem
                }
              },
              "BlockDescriptionListPart",
              _vm.$props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.variant === _vm.OBJECT_BLOCK_VARIANT.OVERVIEW
        ? _vm._t("company")
        : _vm._e(),
      _vm._v(" "),
      _vm.variant === _vm.OBJECT_BLOCK_VARIANT.OVERVIEW
        ? _vm._t("contact")
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }